import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchHistory } from 'src/Libs/installation-details/api/installation-details.api'
import { InstallationHistory } from 'src/Libs/installation-details/models/installation-history.model'
import { usePortalQuery } from 'src/Libs/api'

interface UseInstallationHistoryResultData {
  data: InstallationHistory[] | null
  isLoading: boolean
  hasError: boolean
}

type RefetchFunction = () => void

export const useInstallationHistory = (installationId: string | undefined): [UseInstallationHistoryResultData, RefetchFunction] => {
  const authFetch = useAuthFetchWithResponse()

  const fetchHistoryQueryFn = async (): Promise<InstallationHistory[] | null> => {
    const { error, hasErrors, value } = await fetchHistory(installationId, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching installation history')
    }

    return value
  }

  const { data, isLoading, isError, refetch } = usePortalQuery({
    queryKey: ['installation-history', installationId],
    queryFn: fetchHistoryQueryFn,
    enabled: !!installationId,
  })

  return [
    {
      data: data ?? null,
      isLoading,
      hasError: isError,
    },
    refetch as RefetchFunction,
  ]
}
